import React from 'react';
import type { Contact } from '@hero/schema';
import { useContactDrawerStore } from '@hero/hooks-shared';
import { TableCell } from '../../../ui/Table/Table';
import { MianAvatar } from '../../../app/MianAvatar';
import { Badge } from '../../../ui/Badge/Badge';
import { CellAction } from '../../../app/Table/CellAction';

export interface ContactRowProps {
  contact: Contact;
}

export const ContactRow: React.FC<ContactRowProps> = ({ contact }) => {
  const openDrawer = useContactDrawerStore(s => s.open);
  const handleClick = () => openDrawer(String(contact._id));
  const isOwn = contact.isOwnContact;

  return (
    <>
      <TableCell className="cursor-pointer text-gray-600 body2" onClick={handleClick}>
        <div className="flex items-center gap-3">
          <MianAvatar src="/images/avatar.png" className="size-[44px]" />
          {contact.name}
        </div>
      </TableCell>
      <TableCell className="cursor-pointer text-gray-600 body2" onClick={handleClick}>
        <span dir="ltr">{contact.phone}</span>
      </TableCell>
      <TableCell className="cursor-pointer" onClick={handleClick}>
        <Badge
          variant="secondary"
          className={
            isOwn
              ? 'bg-primary-100 text-logoBlue px-4 py-2'
              : 'bg-gray-100 text-gray-600 px-4 py-2'
          }>
          {isOwn ? 'Own' : 'Other'}
        </Badge>
      </TableCell>
      <TableCell>
        <CellAction type="view" onClick={handleClick} />
      </TableCell>
    </>
  );
};
